import { SingleError } from "@/components/custom/single-error";
import { useNavigate } from "react-router";
import { useAuth } from "@/contexts/auth-context";
import type { UserRole } from "@/types/entities";
import { adminMenuGroups, getTenantMenus } from "@/config/menu";
import { DashboardLayout } from "@/components/layouts/dashboard-layout";
import { ADMIN_SIGNIN_PATH, TENANT_SIGNIN_PATH } from "@/config/constants";

type ProtectedDashboardProps = {
  userType: UserRole,
};

export const ProtectedDashboard = ({ userType }: React.PropsWithChildren<ProtectedDashboardProps>) => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  } 
  
  if (!user || user.type !== userType || (userType === "tenant" && user.tenant == null)) {
    return (
      <SingleError
        error={`You must be logged in as ${userType} to access this page.`}
        nextAction={() => navigate(userType === "admin" ? ADMIN_SIGNIN_PATH : TENANT_SIGNIN_PATH)}
        nextActionText="Sign in"
      />
    );
  }

  const menus = userType === "admin"
    ? adminMenuGroups
    : getTenantMenus(
      user.tenant!.slug,
      user.tenant!.collections,
      user.tenant!.forms,
      user.tenant!.extensions
    );
  return <DashboardLayout menus={menus} />;
};
